import { Button, Divider, Modal, Table } from "antd";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { Api_Url } from "../../../config/config";
import { Link, useNavigate } from "react-router-dom";
import { SuccessToast, UpdatedToast } from "../../../views/ToastComponent";

const AutoDriver = ({ profileId, ProfileId }) => {
  // console.log("mmmmmmm",ProfileId)
  // console.log("ssssmmm",profileId)
  const [isModalOpen, setIsModalOpen] = React.useState(false);
  const [isEditModalOpen, setIsEditModalOpen] = React.useState(false);
  const [areaType, setAreaType] = React.useState([]);
  const [allIncomeData, setAllIncomeData] = React.useState([]);

  const [incomeData, setIncomeData] = React.useState({
    vehicleTypeId: "", areaTypeId: "", registrationNumber: "", ownershipId: "", purchaseCost: 0, lifeAutoTaxiYear: 0, totalDistanceMeter: 0, AgeAutoTaxiMonth: 0, distanceTurn: 0, chargesTurn: 0, Latitude: "", Longitude: "", rent: 0
  });
  const [monthlyDeprecation, setMonthlyDeprecation] = React.useState("");
  const [distanceMonth, setDistanceMonth] = React.useState("");
  const [totalTurnMonth, setTotalTurnMonth] = React.useState("");
  const [monthlyIncome, setMonthlyIncome] = React.useState("");
  const [EditDataId, setEditDataId] = useState(0); // initial will 0 

  const [allBusinessPd, setAllBusinessPd] = React.useState([]);


  const navigate = useNavigate()

  const handleChange = (name, value) => {
    setIncomeData(
      prev => ({
        ...prev,
        [name]: value
      })
    )
  };

  const handleSubmit = async (operationType) => {
    fetchCurentLocation();

    const formData = new FormData();

    formData.append("BusinessPdProfileId", profileId);
    formData.append("VehicleTypeId", incomeData.vehicleTypeId);
    formData.append("ProfitMarginId", incomeData.areaTypeId);
    formData.append("RegistrationNumber", incomeData.registrationNumber);
    formData.append("OwnershipId", incomeData.ownershipId);
    formData.append("Rent", incomeData.rent);
    formData.append("PurchaseCost", incomeData.purchaseCost);
    formData.append("LifeOfAuto", incomeData.lifeAutoTaxiYear);
    formData.append("MonthlyDepreciation", monthlyDeprecation);
    formData.append("TotalDistance", incomeData.totalDistanceMeter);
    formData.append("AgeOfAuto", incomeData.AgeAutoTaxiMonth);
    formData.append("DistanceInMonth", distanceMonth);
    formData.append("DistanceInOneTrip", incomeData.distanceTurn);
    formData.append("TotalTrip", totalTurnMonth);
    formData.append("TripCharges", incomeData.chargesTurn);
    formData.append("MonthlyIncome", monthlyIncome);
    formData.append("Latitude", incomeData.Latitude);
    formData.append("Longitude", incomeData.Longitude);
    let response;
    if (operationType == "Submit") {
      response = await axios.post(Api_Url + "api/v1/AutoDriverPd", formData, {
        headers: {
            Authorization:`Bearer ${JSON.parse(sessionStorage.getItem('user')).accessToken}`
        }
      });
      if (response.data.succeeded) {
        SuccessToast("Created Successfully")
        handleCancel()
        fetchIncomeData();
      }
    } else {
      formData.append("Id", EditDataId)
      response = await axios.post(Api_Url + "api/v1/AutoDriverPd/" + EditDataId, formData, {
        headers: {
          Authorization:`Bearer ${JSON.parse(sessionStorage.getItem('user')).accessToken}`
        }
      });
      if (response.data.succeeded) {
        UpdatedToast("Successfully updated")
        handleCancel()
        fetchIncomeData();
      }
    }
  };

  const vehicleList = [
    { id: 2, name: "Taxi", MonthlyMaintananceCost: 5500 },
    { id: 1, name: "Auto", MonthlyMaintananceCost: 1800 }
  ];
  const ownerList = [
    { id: 1, name: "Self Auto/Taxi" },
    { id: 2, name: "Rented Auto/Taxi" },
    { id: 3, name: "Self Auto/Taxi driven by driver" },
    { id: 4, name: "Self Auto/Taxi given on Lease" },
  ];

  //Single User Id


  // console.log("mmkklk", EditDataId)

  const columns = [
    {
      title: "Area Type",
      dataIndex: "profitMarginName",
    },
    {
      title: "Vehicle",
      dataIndex: "vehicleTypeId",
      render: (text) => {
        const name = vehicleList.length > 0 && vehicleList.filter(vehicle => vehicle?.id == text).map(vehicle => vehicle?.name)
        return <span>{name}</span>
      },
    },
    {
      title: "Registration Number",
      dataIndex: "registrationNumber",
      // sorter: (a, b) => a.registrationNumber.length - b.registrationNumber.length,
    },
    // {
    //   title: "Ownership",
    //   dataIndex: "ownershipId",
    //   render: (text) => {
    //     const name = vehicleList.length > 0 && vehicleList.filter(vehicle => vehicle?.id == text).map(vehicle => vehicle?.name)
    //     return <span>{name}</span>
    //   },
    //   // sorter: (a, b) => a.ownershipId.length - b.ownershipId.length,
    // },
    {
      title: "Purchase Cost",
      dataIndex: "purchaseCost",
      // sorter: (a, b) => a.purchaseCost.length - b.purchaseCost.length,
    },
    {
      title: "Life of Auto",
      dataIndex: "lifeOfAuto",
      // sorter: (a, b) => a.lifeOfAuto.length - b.lifeOfAuto.length,
    },
    {
      title: "Monthly Deprecation",
      dataIndex: "monthlyDepreciation",
      // sorter: (a, b) => a.monthlyDepreciation.length - b.monthlyDepreciation.length,
    },
    {
      title: "Total Distance (as per odometer)",
      dataIndex: "totalDistance",
      // sorter: (a, b) => a.totalDistance.length - b.totalDistance.length,
    },
    {
      title: "Age of Auto/Taxi",
      dataIndex: "ageOfAuto",
      // sorter: (a, b) => a.ageOfAuto.length - b.ageOfAuto.length,
    },
    {
      title: "Distance (one month)",
      dataIndex: "distanceInMonth",
      // sorter: (a, b) => a.distanceInMonth.length - b.distanceInMonth.length,
    },
    {
      title: "Distance covered (one turn)",
      dataIndex: "distanceInOneTrip",
      // sorter: (a, b) => a.distanceInOneTrip.length - b.distanceInOneTrip.length,
    },
    {
      title: "Total Turn (one month)",
      dataIndex: "totalTrip",
      // sorter: (a, b) => a.totalTrip.length - b.totalTrip.length,
    },
    {
      title: "Charge per Turn",
      dataIndex: "tripCharges",
      // sorter: (a, b) => a.tripCharges.length - b.tripCharges.length,
    },
    {
      title: "Monthly Income",
      dataIndex: "monthlyIncome",
      // sorter: (a, b) => a.monthlyIncome.length - b.monthlyIncome.length,
    },
    {
      title: "Actions",
      dataIndex: "actions",
      render: (text, record) => (
        <Button
          // to={`expenses/${record.id}`}
          onClick={() => {
            navigate(`expenses/${record.id}`, {
              // state: { ...record},
              state: { profileId, ProfileId },
              //  state:{}
            });
          }}
        >View Expense</Button>
      ),
    },
    {
      title: 'Edit',
      dataIndex: 'edit',
      // sorter: (a, b) => a.monthlyIncome.length - b.monthlyIncome.length,
      render: (text, record) => (
        <div>
          {text}
          <Button
            type="primary"
            onClick={() => handleClick(record.id)}
            // onClick={() => handleEdit(record.key)}
            style={{ marginLeft: '10px' }}
          >
            <i class="fa-solid fa-pen-to-square"></i>
          </Button>
        </div>
      ),
    },
  ];

  const fetchAreaType = async () => {
    try {
      const { data } = await axios.get(Api_Url + "api/v1/ProfitMargin/getbyprofileid/" + ProfileId, {
        headers: {
          Authorization: "Bearer " + JSON.parse(sessionStorage.getItem("user"))?.accessToken
        }
      })
      setAreaType(data.data);
    } catch (error) {
      console.log(error);
    }
  };


  // const CalcMonthlyIncome = (incomeData.ownershipId == 4) ? (incomeData.rent - monthlyDeprecation) : (totalTurnMonth * incomeData.chargesTurn) - monthlyDeprecation || 0;


  const calculateMonthlyDeprecation = () => {
    const result = (incomeData.purchaseCost / incomeData.lifeAutoTaxiYear) / 12 || 0;
    setMonthlyDeprecation(result.toFixed(2));
  };

  const calculateDistanceCovered = () => {
    const result = incomeData.totalDistanceMeter / incomeData.AgeAutoTaxiMonth || 0
    setDistanceMonth(result.toFixed(2));
  };

  const calculateTotalTurn = () => {
    const result = distanceMonth / incomeData.distanceTurn || 0
    setTotalTurnMonth(result.toFixed(2));
  };

  const calculateChargesTurn = () => {
    const multiplied = totalTurnMonth * incomeData.chargesTurn || 0
    const result = incomeData.ownershipId == 4 ? incomeData.rent - monthlyDeprecation : multiplied - (monthlyDeprecation + incomeData.rent) || 0
    setMonthlyIncome(result.toFixed(2));
  };

  /** Calculate Monthly Deprecation */
  React.useEffect(() => {
    calculateMonthlyDeprecation()
  }, [incomeData.purchaseCost, incomeData.lifeAutoTaxiYear]);

  /** Calculate Distance covered in One Month */
  React.useEffect(() => {
    calculateDistanceCovered()
  }, [incomeData.totalDistanceMeter, incomeData.AgeAutoTaxiMonth]);

  /** Calculate Total Turn in Month */
  React.useEffect(() => {
    calculateTotalTurn()
  }, [distanceMonth, incomeData.distanceTurn]);

  /** Calculate Monthly Income */
  React.useEffect(() => {
    calculateChargesTurn()
  }, [totalTurnMonth, incomeData.chargesTurn,incomeData.rent,incomeData.ownershipId]);

  const fetchCurentLocation = () => {
    if ("geolocation" in navigator) {
      navigator.geolocation.getCurrentPosition(function (position) {
        const { latitude, longitude } = position.coords;
        setIncomeData(prev => ({ ...prev, Latitude: latitude, Longitude: longitude }))
      });
    } else {
      return "Geolocation is not supported by this browser."
    }
  };

  const fetchIncomeData = async () => {
    const { data } = await axios.get(Api_Url + "api/v1/AutoDriverPd/getbybusinesspdprofileid/" + profileId, {
      headers: {
        Authorization: "Bearer " + JSON.parse(sessionStorage.getItem("user"))?.accessToken
      }
    });
    setAllBusinessPd(data)
  };

  React.useEffect(() => {
    fetchAreaType();
    fetchCurentLocation();
    fetchIncomeData();
  }, []);


  async function handleCancel() {
    setIncomeData({
      ...incomeData,
      vehicleTypeId: "",
      areaTypeId: "",
      registrationNumber: "",
      ownershipId: "",
      purchaseCost: 0,
      lifeAutoTaxiYear: 0,
      totalDistanceMeter: 0,
      AgeAutoTaxiMonth: 0,
      distanceTurn: 0,
      chargesTurn: 0,
      rent: 0
    })
    setEditDataId(0)
    setTotalTurnMonth("")
    setMonthlyDeprecation("")
    setDistanceMonth("")
    setMonthlyIncome("")
    setIsModalOpen(false);
  }

  const handleClick = async (id) => {

    setEditDataId(id)
    setIsModalOpen(true)

  }

  async function LoadSingleAutoDriver(hereId) {
    try {
      const response = await axios.get(`${Api_Url}api/v1/AutoDriverPd/${hereId}`, {
        headers: {
          Authorization: `Bearer ${JSON.parse(sessionStorage.getItem('user')).accessToken}`,
        }
      })
      setIncomeData({
        ...incomeData,
        vehicleTypeId: response.data.data.vehicleTypeId,
        areaTypeId: response.data.data.profitMarginId,
        registrationNumber: response.data.data.registrationNumber,
        ownershipId: response.data.data.ownershipId,
        purchaseCost: response.data.data.purchaseCost,
        lifeAutoTaxiYear: response.data.data.lifeOfAuto,
        totalDistanceMeter: response.data.data.totalDistance,
        AgeAutoTaxiMonth: response.data.data.ageOfAuto,
        distanceTurn: response.data.data.distanceInOneTrip,
        chargesTurn: response.data.data.tripCharges,
        rent: response.data.data.rent,
        monthlyDepreciation: response.data.data.monthlyDepreciation,
      })
    } catch (e) {
      console.log("Load Single Auto Driver", e.message)
    }
  }

  useEffect(() => {
    if (EditDataId !== 0) {

      LoadSingleAutoDriver(EditDataId)
    }
  }, [EditDataId !== 0])

  return (

    <div className="container mt-3">
      <div className="row">
        <div className="col-12 d-flex align-items-center justify-content-end">
          <button className="btn btn-primary submit-btn" onClick={() => setIsModalOpen(true)}>Add Income</button>
        </div>
      </div>

      <div className="row mt-4">
        <div className="col-12 mx-auto">
          <Table
            className="table-striped"
            style={{ overflowX: "auto" }}
            columns={columns}
            dataSource={allBusinessPd}
            rowKey={(record) => record.id}
          />
        </div>
      </div>

      {/* Income Form Modal */}
      <Modal
        title={<h4>{EditDataId == 0 ? "Add" : "Edit"} Auto Driver</h4>}
        open={isModalOpen}
        onOk={() => setIsModalOpen(false)}
        // closable={false}
        onCancel={() => handleCancel()}
        footer={[
          <div className="d-flex justify-content-between align-items-center">
            <button key="Cancel" className="btn btn-danger submit-btn" type="button" onClick={handleCancel}>Cancel</button>,
            <button key="submit" className="btn btn-primary submit-btn" type="submit" onClick={() => handleSubmit(EditDataId == 0 ? "Submit" : "Edit")}>{EditDataId == 0 ? "Submit" : "Update"}</button>
          </div>
        ]}
        width={600}
        mask={false}
        maskClosable={false}
        closeIcon={<span style={{ color: 'red' }}>X</span>}
      >
        <div className="modal-body mt-5">
          <form>
            <div className="row">
              <div className="col-sm-6">
                <div className="input-block mb-3">
                  <label htmlFor="vehicleType" className="col-form-label">
                    Select Vehicle Type
                  </label>
                  <select id="vehicleType" className="custom-select-style" value={incomeData.vehicleTypeId} onChange={event => handleChange("vehicleTypeId", event.target.value)}>
                    <option value="" selected>Select Vehicle Type</option>
                    {vehicleList.map(vehicle => <option value={vehicle.id}>{vehicle.name}</option>)}
                  </select>
                </div>
              </div>
              <div className="col-sm-6">
                <div className="input-block mb-3">
                  <label htmlFor="areaType" className="col-form-label">
                    Select Area Type
                  </label>
                  <select id="areaType" className="custom-select-style" value={incomeData.areaTypeId} onChange={event => handleChange("areaTypeId", event.target.value)}>
                    <option value="" selected>Select Area Type</option>
                    {areaType.length > 0 && areaType.map(area => <option value={area.id}>{area.name}</option>)}
                  </select>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-sm-12">
                <div className="input-block mb-3">
                  <label className="col-form-label">
                    Registration Number
                  </label>
                  <input className="form-control" type="text" placeholder="Registration Number" value={incomeData.registrationNumber} onChange={event => handleChange("registrationNumber", event.target.value)} />
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-sm-12">
                <div className="input-block mb-3">
                  <label htmlFor="ownership" className="col-form-label">
                    Select Ownership
                  </label>
                  <select id="ownership" className="custom-select-style" value={incomeData.ownershipId} onChange={event => handleChange("ownershipId", event.target.value)}>
                    <option value="" selected>Select Ownership</option>
                    {ownerList.map(vehicle => <option value={vehicle.id}>{vehicle.name}</option>)}
                  </select>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-sm-6">
                <div className="input-block mb-3">
                  <label htmlFor="purchaseCost" className="col-form-label">
                    Purchase Cost
                  </label>
                  <input className="form-control" id="purchaseCost" type="number" placeholder="Purchase Cost" value={incomeData.purchaseCost} onChange={event => handleChange("purchaseCost", event.target.value)} />
                </div>
              </div>
              <div className="col-sm-6">
                <div className="input-block mb-3">
                  <label htmlFor="life" className="col-form-label">
                    Life of Auto/Taxi (Year)
                  </label>
                  <input className="form-control" id="life" type="number" placeholder="Life of Auto/Taxi (Year)" value={incomeData.lifeAutoTaxiYear} onChange={event => handleChange("lifeAutoTaxiYear", event.target.value)} />
                </div>
              </div>
            </div>
            <div className="row my-3">
              <div className="col-sm-12 d-flex align-items-center justify-content-between">
                <p className="mb-0">Monthly Depreciation: </p>
                <span className="mb-0 bg-dark py-1 px-2 text-light fw-bold rounded">{monthlyDeprecation == NaN ? "0.00" : monthlyDeprecation}</span>
              </div>
            </div>
            <Divider plain></Divider>

           {(incomeData.ownershipId == "2" || incomeData.ownershipId == "4") && 
           (
            <div className="row">
            <div className="col-sm-12">
              <div className="input-block mb-3">
                <label htmlFor="distanceTurn" className="col-form-label">
                  Rent:
                </label>
                <input className="form-control" id="rent" type="number" placeholder="Enter Rent" value={incomeData.rent} onChange={event => handleChange("rent", event.target.value)} />
              </div>
            </div>
          </div>
           )
           }

            <div className="row">
              <div className="col-sm-6">
                <div className="input-block mb-3">
                  <label htmlFor="odometer" className="col-form-label">
                    Total Distance covered as per odometer
                  </label>
                  <input className="form-control" id="odometer" type="number" placeholder="Total Distance covered as per odometer" value={incomeData.totalDistanceMeter} onChange={event => handleChange("totalDistanceMeter", event.target.value)} />
                </div>
              </div>
              <div className="col-sm-6">
                <div className="input-block mb-3">
                  <label htmlFor="ageAutoTaxi" className="col-form-label">
                    Age of Auto/Taxi (months)
                  </label>
                  <input className="form-control" id="ageAutoTaxi" type="number" placeholder="Age of Auto/Taxi (months)" value={incomeData.AgeAutoTaxiMonth} onChange={event => handleChange("AgeAutoTaxiMonth", event.target.value)} />
                </div>
              </div>
            </div>
            <div className="row my-3">
              <div className="col-sm-12 d-flex align-items-center justify-content-between">
                <p className="mb-0">Distance covered in One Month: </p>
                <span className="mb-0 bg-dark py-1 px-2 text-light fw-bold rounded">{distanceMonth}</span>
              </div>
            </div>
            <Divider plain></Divider>
            <div className="row">
              <div className="col-sm-12">
                <div className="input-block mb-3">
                  <label htmlFor="distanceTurn" className="col-form-label">
                    Distance covered in one Turn
                  </label>
                  <input className="form-control" id="distanceTurn" type="number" placeholder="Distance covered in one Turn" value={incomeData.distanceTurn} onChange={event => handleChange("distanceTurn", event.target.value)} />
                </div>
              </div>
            </div>
            <div className="row my-3">
              <div className="col-sm-12 d-flex align-items-center justify-content-between">
                <p className="mb-0">Total Turn in Month: </p>
                <span className="mb-0 bg-dark py-1 px-2 text-light fw-bold rounded">{totalTurnMonth}</span>
              </div>
            </div>
            <Divider plain></Divider>
            <div className="row">
              <div className="col-sm-12">
                <div className="input-block mb-3">
                  <label htmlFor="chargesPerTurn" className="col-form-label">
                    Charges Per Turn
                  </label>
                  <input className="form-control" id="chargesPerTurn" type="number" placeholder="Charges Per Turn" value={incomeData.chargesTurn} onChange={event => handleChange("chargesTurn", event.target.value)} />
                </div>
              </div>
            </div>
            <div className="row my-3 mb-5">
              <div className="col-sm-12 d-flex align-items-center justify-content-between">
                <p className="mb-0">Monthly Income: </p>
                <span className="mb-0 bg-dark py-1 px-2 text-light fw-bold rounded">{monthlyIncome}</span>
              </div>
            </div>
          </form>
        </div>
      </Modal>
    </div>

  )
}

export default AutoDriver